import React from 'react';
import { Select2, Select2Props } from '@economic/taco';
import { t } from '@lingui/macro';
import { Country, EmptyCountry } from '~/app/shared/components/ui/dropdowns/CountryDropdown/types';
import countries from '~/app/shared/components/ui/dropdowns/CountryDropdown/countries';
import { CountryCodes } from './countryCodes';
import { GetCountryTranslations } from './countryTranslations';

export function isValidCountry(country: string): boolean {
    return countries.some(c => c.name === country);
}

export function CountryDropdown(props: Omit<Select2Props, 'children'>) {
    let listOptions = countries;

    if (!isValidCountry(props.defaultValue as string) && props.defaultValue !== EmptyCountry) {
        listOptions = [{ name: props.defaultValue as string, code: CountryCodes.NAN }, ...listOptions];
    }

    return (
        <Select2 className="w-full" aria-label={t`countries`} emptyValue={EmptyCountry} {...props}>
            {listOptions.map((country: Country) => (
                <Select2.Option
                    key={country.code}
                    value={country.name}
                    prefix={
                        country.code !== CountryCodes.NAN ? (
                            <span className={`m-1 fi fi-${country.code.toLowerCase()}`} />
                        ) : undefined
                    }>
                    {GetCountryTranslations(country.code) || country.name}
                </Select2.Option>
            ))}
        </Select2>
    );
}
